import { render, staticRenderFns } from "./PricingLogoBelt.vue?vue&type=template&id=772300ff&"
import script from "./PricingLogoBelt.vue?vue&type=script&lang=ts&"
export * from "./PricingLogoBelt.vue?vue&type=script&lang=ts&"
import style0 from "./PricingLogoBelt.vue?vue&type=style&index=0&id=772300ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BContainer: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/BContainer.vue').default})
